export default __webpack_public_path__ + "507f3945cae496f7ad7b3901a26e332d.svg";